module.exports = __webpack_public_path__ + "img/character-default.5bf35348.png";